import React from 'react';
import ReactDOM from 'react-dom';

import ProductItem from './product-item.jsx';
import CollectionFilter from './collection-filter.jsx';
import lazyImage from '../components/lazy-images'
// import storefrontApi from '../components/storefront-api'
import Modal from '../components/Modal';
import 'url-polyfill';

class CollectionOut extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.products = this.props.data.products;
    this.collection = this.props.data.collection;
    this.hasMorePages = true;
    this.productCount = 0;
    this.filteredCount = 0;
    this.pageNumber = 1;
    this.modal = new Modal();

    // this.pages = this.props.data.pagination.pages;
    this.url = `/collections/${this.collection.handle}`;
    this.location = new URL(window.location);
    // this.currentPage = this.props.data.pagination.current_page;
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.io.unobserve(entry.target);
          fetch(`${this.url}?view=data&page=${this.pageNumber}`).then((data) => {
            return data.json();
          }).then((myJson) => {
            const productArray = myJson.products;
            this.hasMorePages = myJson.nextPage;
            this.pageNumber++;
            this.productCount += productArray.length;
            this.setState(prevState => ({
              products: [...prevState.products, ...productArray]
            }), this.handleNextPage)
          })
          
          /* storefrontApi(requestData)
            .then((myJson) => {
              const productArray = myJson.data.collectionByHandle.products.edges;
              this.hasMorePages = myJson.data.collectionByHandle.products.pageInfo.hasNextPage;
              this.after = `, after: "${productArray[productArray.length - 1].cursor}"`
              this.productCount += productArray.length;
              this.setState(prevState => ({
                products: [...prevState.products, ...productArray]
              }), this.handleNextPage)
            }); */
        }
      });
    }, { rootMargin: '1200px' });

    const currentFilters = new Set();
    const currentFiltersObj = {};

    if (this.location.searchParams.get('filter')) {
      const currentFiltersArray = this.location.searchParams.get('filter').split(',');
      for (let filter of currentFiltersArray) {
        const filterArray = filter.split('_');
        currentFiltersObj[filterArray[0]] = currentFiltersObj[filterArray[0]] || [];
        currentFiltersObj[filterArray[0]].push(filter);
        currentFilters.add(filter)
      }
    }

    this.state = {
      currentFilters,
      products: [],
      currentFiltersObj
    }

    this.filterChange = this.filterChange.bind(this)
    this.filterCheck = this.filterCheck.bind(this)
    this._showFiltersModal = this._showFiltersModal.bind(this);
    this._closeFiltersModal = this._closeFiltersModal.bind(this);
  }

  filterChange(currentFilters) {
    const currentFiltersObj = {};
    for (let filter of currentFilters) {
      const filterArray = filter.split('_');
      currentFiltersObj[filterArray[0]] = currentFiltersObj[filterArray[0]] || [];
      currentFiltersObj[filterArray[0]].push(filter);
    }
    this.setState({
      currentFilters,
      currentFiltersObj
    }, () => {
      this.location.searchParams.set('filter', [...this.state.currentFilters].join(','));
      history.replaceState(this.state.currentFiltersObj, '', this.location);
    })
  }

  filterCheck(productTags) {
    let ret = true;

    for (let f of Object.keys(this.state.currentFiltersObj)) {
      let matchFound = false;
      for (let v of this.state.currentFiltersObj[f]) {
        if (productTags.includes(v)) {
          matchFound = true
          break
        }
      }
      if (!matchFound) {
        ret = false
        break
      }
    }

    this.filteredCount+=ret;

    return ret
  }

  handleNextPage() {
    this.productCount = this.state.products.length;
    if (this.hasMorePages) {
      this.io.observe(this.bumper);
    } else {
      this.io.disconnect();
    }
  }

  _showFiltersModal(event) {
    this.modal.open('[data-productgrid-filters-content]', 'productgrid-filters');
  }

  _closeFiltersModal(event) {
    this.modal.close();
  }

  componentDidMount() {
    this.bumper = document.querySelector('.bumper');
    this.io.observe(this.bumper);
  }

  componentDidUpdate() {
    lazyImage();
    try {
      window.StampedFn && window.StampedFn.loadBadges();
    } catch (error) {
      console.log('Couldn\'t load Stamped');
    }
  }

  render() {
    this.filteredCount = 0;
    return <div className={`productgrid--outer productgrid-gridview ${(()=>{if (this.props.data.collection_tags.length) return 'layout--has-sidebar'; else return 'layout--no-sidebar'})()}`}>
      <CollectionFilter tags={this.props.data.collection_tags} callback={this.filterChange} currentFilters={this.state.currentFilters} closeFn={this._closeFiltersModal} />
      <div className="productgrid--wrapper">
        <nav className="productgrid--utils productgrid--utils--visible-mobile" aria-label="Collection utilities">
          <div className="productgrid--utils utils-filter">
            <button className="utils-filter-button" type="button" aria-label="Filters" data-productgrid-trigger-filters="" onClick={this._showFiltersModal}>
              <span className="utils-filter-icon">
                <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13">
                  <path fill="currentColor" fillRule="evenodd" d="M16.516 2.25h2.474v1.5h-2.474a2.626 2.626 0 0 1-5.032 0H0v-1.5h11.484a2.626 2.626 0 0 1 5.032 0zm-9 7h11.472v1.5H7.516a2.626 2.626 0 0 1-5.032 0H0v-1.5h2.484a2.626 2.626 0 0 1 5.032 0zM5 11.375a1.375 1.375 0 1 1 0-2.75 1.375 1.375 0 0 1 0 2.75zm9-7a1.375 1.375 0 1 1 0-2.75 1.375 1.375 0 0 1 0 2.75z"></path>
                </svg>
              </span>
              <span className="utils-filter-text">Filters {this.state.currentFilters.size > 0 ? `(${this.state.currentFilters.size})` : ``}</span>
            </button>
          </div>
        </nav>
        <div className="productgrid--items products-per-row-4">
          {this.state.products.map((product, i) => {
            return <ProductItem product={product} key={i} filter={this.state.currentFilters} filterObj={this.state.currentFiltersObj} filterCheck={this.filterCheck(product.tags)} />
          })}
        </div>
        <div className={this.hasMorePages ? 'bumper' : 'hidden bumper'}>
          <svg
            className="bumper-spinner"
            aria-hidden="true"
            focusable="false"
            role="presentation"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fillRule="nonzero" fill="currentColor">
              <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29" /><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z" />
            </g>
          </svg>
        </div>
        <div className={(this.hasMorePages || this.filteredCount > 0) ? 'hidden productgrid--no-results' : 'productgrid--no-results'}>
          <h2 className="productgrid--no-results-title">No results found. Try removing some filters.</h2>
        </div>
      </div>
    </div>
  }
}

export default class Collection {
  constructor(data, elem) {
    this.data = data;
    this.elem = elem;
    ReactDOM.render(<CollectionOut data={this.data} />, elem);
  }

  destructor() {
    ReactDOM.unmountComponentAtNode(this.elem)
  }
}
